import type React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useFavorite,
  useOpenEditor,
  useProgramAuthor,
  useProgramDelete,
  useProgramShare,
  useRecommendModal,
} from '@features/programs';
import { MoreHoriz } from '@shared/assets';
import { useUser } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import type { Program } from '@shared/types/programs';
import { IconButton, MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui';
import st from './styles.module.scss';

type Props = {
  program: Program;
  saveCurrentPos: () => void;
  authorId?: number;
};

export const MainMenu: React.FC<Props> = ({ program, saveCurrentPos, authorId }) => {
  const { pk, favorite, is_paid } = program;
  // refactoring
  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();
  const { isAuthor } = useProgramAuthor(program.author.id);
  const { toggleRecommendModal } = useRecommendModal();
  const { favoriteBtn } = useFavorite({ programId: pk, isFavorite: favorite, isPaid: is_paid });
  const { edit } = useOpenEditor(pk);
  const { removeProgram } = useProgramDelete(pk);
  const { permissions, code } = useModuleByCodeParam();
  const { toggleShareModal } = useProgramShare();
  const { isAuth } = useUser();
  const navigate = useNavigate();
  return (
    <>
      <IconButton
        className={st.moreBtn}
        key={`IconButton-${pk}`}
        id={`button-${pk}`}
        onClick={onOpen}
        ref={(ref) => setReferenceEl(ref)}
        variant="transparent"
      >
        <MoreHoriz />
      </IconButton>
      <MenuDropdown
        id={pk}
        referenceEl={referenceEl}
        popperEl={popperEl}
        setPopperEl={setPopperEl}
        key={`MenuDropdown-${pk}`}
      >
        {isAuthor && (
          <MenuItem
            key={pk + 'Изменить'}
            onClick={(e) => {
              saveCurrentPos();
              onClose(e);
              edit();
              window.scrollTo(0, 0);
            }}
          >
            Изменить
          </MenuItem>
        )}

        {permissions.can_sell && (
          <MenuItem
            key={pk + 'Рекомендовать'}
            onClick={(e) => {
              onClose(e);
              toggleRecommendModal(pk);
            }}
          >
            Рекомендовать
          </MenuItem>
        )}

        {isAuthor && (
          <MenuItem
            key={pk + 'Публикация'}
            onClick={(e) => {
              saveCurrentPos();
              navigate(`/programs/${code}/program/${pk}/publication`);
              onClose(e);
            }}
          >
            Публикация
          </MenuItem>
        )}

        {!isAuthor && authorId && (
          <MenuItem
            key={pk + 'об авторе'}
            onClick={(e) => {
              saveCurrentPos();
              navigate(`/coaches/specialists/${authorId}`);
              onClose(e);
            }}
          >
            Об авторе
          </MenuItem>
        )}

        {!isAuthor && isAuth && (
          <MenuItem
            key={pk + 'Избранное'}
            onClick={(e) => {
              onClose(e);
              favoriteBtn.onClick();
            }}
          >
            {favoriteBtn.text}
          </MenuItem>
        )}

        {((permissions.can_buy && !permissions.can_sell) || !isAuth) && (
          <MenuItem
            key={pk + 'Поделиться'}
            // sx={{ fontSize: '14px' }}
            onClick={(e) => {
              onClose(e);
              // e.stopPropagation();
              toggleShareModal(pk);
            }}
          >
            Поделиться
          </MenuItem>
        )}

        {isAuthor && (
          <MenuItem
            key={pk + 'Удалить'}
            onClick={(e) => {
              onClose(e);
              removeProgram();
            }}
          >
            Удалить
          </MenuItem>
        )}
      </MenuDropdown>
    </>
  );
};
